import React from 'react';

import { SVGComponentProps } from './svg.types';

const EyeAltSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...otherProps}
    >
      <path
        d="M0.787109 8C1.41412 4.58651 4.40476 2 7.99955 2C11.5943 2 14.5849 4.58651 15.2119 8C14.5849 11.4135 11.5943 14 7.99955 14C4.40476 14 1.41412 11.4135 0.787109 8ZM7.99955 11.3333C9.84048 11.3333 11.3329 9.84093 11.3329 8C11.3329 6.15905 9.84048 4.66667 7.99955 4.66667C6.15858 4.66667 4.66619 6.15905 4.66619 8C4.66619 9.84093 6.15858 11.3333 7.99955 11.3333ZM7.99955 10C6.89495 10 5.99952 9.1046 5.99952 8C5.99952 6.8954 6.89495 6 7.99955 6C9.10408 6 9.99955 6.8954 9.99955 8C9.99955 9.1046 9.10408 10 7.99955 10Z"
        fill={fill}
      />
    </svg>
  );
};

export default EyeAltSVG;
